import { create } from "zustand";

export type AuthSession = {
  id: string;
  email: string;
};

type AuthState = {
  session: AuthSession | null;
  isLoadingAuth: boolean;
  setSession: (session: AuthSession | null) => void;
  setLoadingAuth: (v: boolean) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  isLoadingAuth: true,
  setSession: (session) => set({ session }),
  setLoadingAuth: (v) => set({ isLoadingAuth: v }),
  logout: () => set({ session: null, isLoadingAuth: false }),
}));
